import { render, staticRenderFns } from "./CmgChipotleUAccountModalStudentProfile.vue?vue&type=template&id=9a8c93e4&scoped=true&lang=pug"
import script from "./cmg-chipotle-u-account-modal-student-profile.ts?vue&type=script&lang=ts&external"
export * from "./cmg-chipotle-u-account-modal-student-profile.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgChipotleUAccountModalStudentProfile.vue?vue&type=style&index=0&id=9a8c93e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a8c93e4",
  null
  
)

export default component.exports